export const REQUEST_SOURCE_HEADER = 'X-Request-Source'

const REPO_SOURCE_NAME = 'tribe-neo'

export const SSR_HEADER_VALUE = `${REPO_SOURCE_NAME}-ssr`
export const CSR_HEADER_VALUE = `${REPO_SOURCE_NAME}-csr`
